export const AppEventsLogger = () => {
  return {
    logEvent() {
      console.log('@todo');
    },
  };
};
